module.exports = __webpack_public_path__ + "img/keyboardErrorBg.6dc6c928.png";